import moment from "moment";
import { ApiRegistration } from "src/api/types";
import Badge from "src/components/Badge";
import Indicator from "src/components/layout/Indicator";
import ListItem from "src/components/lists/list-items/ListItem";
import RegistrationStatus from "src/components/RegistrationStatus";
import Stars from "src/components/Stars";
import useAuth from "src/hooks/selectors/useAuth";
import useWindowSize from "src/hooks/useWindowSize";

interface RegistrationListItemProps {
	registration: ApiRegistration;
}

const RegistrationListItem = ({ registration }: RegistrationListItemProps) => {
	const { isTablet } = useWindowSize();
	const auth = useAuth();
	const user: any = registration?.user;
	const status = registration.status;

	return (
		<ListItem
			to={`/tasks/${registration?.task?.hid}/show/${registration?.hid}`}
			bordered
			align="center"
			key={registration.id + registration.hid}
		>
			<div className="relative">
				<ListItem.Avatar
					size="medium"
					src={registration?.user?.avatar}
				/>
				{registration?.unread_messages > 0 && (
					<div className="absolute -bottom-2 -left-2">
						<Indicator>{registration.unread_messages}</Indicator>
					</div>
				)}
				{registration?.is_connected && (
					<div className="absolute -bottom-2 -right-2">
						<Badge size="xsmall" variant="primary">
							<div className="flex justify-center items-center w-4 h-4 leading-1">
								🤝🏻
							</div>
						</Badge>
					</div>
				)}
			</div>
			<ListItem.Content className="gap-2">
				<div className="flex flex-wrap gap-1 justify-between">
					{auth?.has_subscription && (
						<ListItem.Title>{user?.full_name}</ListItem.Title>
					)}
					<div className="mr-8">
						{user?.review > 0 && (
							<Stars rating={registration?.user?.review || 0} />
						)}
					</div>
				</div>
				<ListItem.Text variant={!isTablet ? "small" : undefined}>
					{isTablet && (
						<div className="mt-2 mb-2">{registration?.excerpt}</div>
					)}
				</ListItem.Text>
				<div className="flex items-center justify-between">
					<RegistrationStatus size="xsmall" {...{ status }} />
					<small className="text-right opacity-20">
						{moment(registration.created_at).fromNow()}
					</small>
				</div>
			</ListItem.Content>
		</ListItem>
	);
};

export default RegistrationListItem;
